// source: cloud_signal_properties.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.EDM.IPC.cloud_signal_properties', null, global);
goog.exportSymbol('proto.EDM.IPC.vds_triax', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EDM.IPC.cloud_signal_properties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.EDM.IPC.cloud_signal_properties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.EDM.IPC.cloud_signal_properties.displayName = 'proto.EDM.IPC.cloud_signal_properties';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.toObject = function(opt_includeInstance) {
  return proto.EDM.IPC.cloud_signal_properties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EDM.IPC.cloud_signal_properties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EDM.IPC.cloud_signal_properties.toObject = function(includeInstance, msg) {
  var f, obj = {
    device: jspb.Message.getFieldWithDefault(msg, 1, 0),
    channelGuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    triax: jspb.Message.getFieldWithDefault(msg, 3, 0),
    frameIndex: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EDM.IPC.cloud_signal_properties}
 */
proto.EDM.IPC.cloud_signal_properties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.EDM.IPC.cloud_signal_properties;
  return proto.EDM.IPC.cloud_signal_properties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EDM.IPC.cloud_signal_properties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EDM.IPC.cloud_signal_properties}
 */
proto.EDM.IPC.cloud_signal_properties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDevice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelGuid(value);
      break;
    case 3:
      var value = /** @type {!proto.EDM.IPC.vds_triax} */ (reader.readEnum());
      msg.setTriax(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrameIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.EDM.IPC.cloud_signal_properties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EDM.IPC.cloud_signal_properties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EDM.IPC.cloud_signal_properties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getChannelGuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTriax();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFrameIndex();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int64 device = 1;
 * @return {number}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.getDevice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.cloud_signal_properties} returns this
 */
proto.EDM.IPC.cloud_signal_properties.prototype.setDevice = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string channel_guid = 2;
 * @return {string}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.getChannelGuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.EDM.IPC.cloud_signal_properties} returns this
 */
proto.EDM.IPC.cloud_signal_properties.prototype.setChannelGuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional vds_triax triax = 3;
 * @return {!proto.EDM.IPC.vds_triax}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.getTriax = function() {
  return /** @type {!proto.EDM.IPC.vds_triax} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.EDM.IPC.vds_triax} value
 * @return {!proto.EDM.IPC.cloud_signal_properties} returns this
 */
proto.EDM.IPC.cloud_signal_properties.prototype.setTriax = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 frame_index = 4;
 * @return {number}
 */
proto.EDM.IPC.cloud_signal_properties.prototype.getFrameIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.cloud_signal_properties} returns this
 */
proto.EDM.IPC.cloud_signal_properties.prototype.setFrameIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.EDM.IPC.vds_triax = {
  VDS_TRIAX_UNKNOWN: 0,
  R: 1,
  T: 2,
  A: 3
};

goog.object.extend(exports, proto.EDM.IPC);
